// which parts of the app are restricted?
//export default ['huisartsenzorg']
//export default ['ouderenzorg', 'publieke-gezondheidszorg']
//export default ['ouderenzorg']
export default ['geneesmiddelenzorg'];
